module.exports = {
	"_comment": "This is a generated version.json file. Do not attempt to modify. Modify Version from package.json file.",
	"version": "4.2.0929",
	"date": "29, Sep, 2017"
};


//////////////////
// WEBPACK FOOTER
// ./src/js/geico-design-kit/version.json
// module id = 12
// module chunks = 0 1